import React, { useEffect, useState } from 'react'

import { Grid, TextField, Button, Paper, Typography } from '@material-ui/core';

import { fetchConToken } from '../../helpers/fetch';
import { handleErrorApi } from '../../helpers/randoms';
import { finishSpinner, startSpinner } from '../../actions/ui/spinner';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../actions/ui/alertas';
import { useHistory } from 'react-router-dom';
import { startLogout } from '../../actions/auth';
import { IconWithText } from './IconWithText';

const texto = "Borrar";

const padNumerico = {
    teclas: [
        "1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", {icon: <IconWithText text={texto} /> } 
    ],
    style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "2.5em",
        backgroundColor: '#A178C5',
        color: "#fff",
        padding: "0.5em",
        transition: "background-color 0.3s ease"
    },
    hoverStyles: {
        backgroundColor: '#7F5A91',
    }
}

export const BuscadorPad = ({setValue, endpoint, label, onChange}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [inputValue, setInputValue] = useState('');
    
    const salirSesionApp = () => {
        dispatch(startLogout(history));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if(inputValue === '14736925800') salirSesionApp();
        else dispatch(handleSearch());

        setInputValue("");
    }

    const handleSearch = () => 
    async (dispatch) => {
        try {
            dispatch(startSpinner());
            const response = await fetchConToken(endpoint(inputValue));
            if(response.status === 204){
                dispatch(startAlerta("No se encontro resultado con el número ingresado", "error"));
                dispatch(finishSpinner());
            }else{
                const body = await response.json();
                if (response.ok) {
                    onChange(body);
                } else {
                    throw body;
                }
            }
        } catch (error) {
            dispatch(finishSpinner());
            setValue(null); 
            handleErrorApi(dispatch, error, "Error al traer afiliado", "Ha ocurrido un error. Intente nuevamente");
        }
    };

    const TecladoNumerico = () => (
      <Grid container spacing={2} justify='center' style={{margin: "1em 0", display: "flex", justifyContent: "center", gap: "0.8em"}}>
        {
          padNumerico.teclas.map( (tecla, index) => (
            <Grid key={index} 
                item xs={3} 
                component={Paper} 
                elevation={3}
                onMouseOver={e => e.currentTarget.style.backgroundColor = !!tecla ? padNumerico.hoverStyles.backgroundColor : padNumerico.style.backgroundColor}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = padNumerico.style.backgroundColor}
                onClick={() => {
                    if(tecla?.icon){
                        setInputValue(inputValue.slice(0, inputValue.length - 1)); 
                    }else{
                        if (typeof tecla !== 'object'){
                            if(inputValue.length <= 10) setInputValue(inputValue + tecla);
                            else setInputValue(inputValue);
                        }
                    }
                }}
                style={{...padNumerico.style, cursor: !!tecla ? "pointer" : "default"}} 
                disabled={!!tecla ? true : false}
            >
              {tecla?.icon ? tecla.icon : tecla}
            </Grid>
          ))
        }
      </Grid>
    );

    useEffect(() => { 
        let timer;
        if (inputValue) { 
            timer = setTimeout(() => {
                setInputValue("");
            }, 20000);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [inputValue]);
    
    return (
        <Grid container justify='center' alignItems='center'>
            <ValidatorForm onSubmit={handleSubmit}>
                <Grid item xs={12}>
                    <Grid 
                        container spacing={1}
                        component={Paper} elevation={3} 
                        style={{padding: "0.5em", display: "flex", justifyContent: "center", alignItems: "center"}}
                    >
                        <Typography variant='button' style={{fontSize: "1.4em"}}>Ingresá tu número de DNI o credencial</Typography>
                        <Grid item xs={12} md={11}>
                            <TextField
                                variant="standard"
                                margin='normal'
                                color="warning"
                                fullWidth
                                label={label}
                                autoComplete="off"
                                type="number"
                                disabled
                                value={inputValue} 
                                InputLabelProps={{ style: { fontWeight: 'bold', fontSize: "1.8em", color: "black" }}}
                                inputProps={{ style: { fontSize: "1.8em", color: "black" }}}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TecladoNumerico />
                        </Grid>
                        <Button
                            type='submit'
                            variant='contained'
                            color='primary'
                            size='large'
                            fullWidth
                            disabled={inputValue.length <= 6}
                            style={{margin: "1em", fontSize: "1.5em"}}
                        >
                            ACEPTAR
                        </Button>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Grid>
    );
}

export default BuscadorPad;